import { useState, useEffect, useRef } from "react";
import { Box, Typography, Card, Container, IconButton,useMediaQuery, useTheme } from "@mui/material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NextStepCard from "../Home/NextStepCard";

const testimonials = [
    {
        companyLogo: "/companyLogo2.png",
        title: "A Game-Changer for Our Business",
        description:
            "After struggling with unfavourable loans following the impact of COVID-19, we turned to Mr. Amit Ruhela and his team for assistance. Their deep financial expertise, combined with years of experience working with businesses in similar situations, proved invaluable. Mr. Ruhela not only approached our challenges with empathy and understanding, but also provided sound, strategic advice that was tailored to our needs. His team's strong rapport with multiple banks played a pivotal role in securing a deal that exceeded our expectations.\n\nThroughout the process, Mr. Ruhela and Team Dequitec were diligent, efficient, and worked tirelessly to ensure that every aspect was handled swiftly and professionally. I have no hesitation in recommending his services to anyone seeking new debt or looking to secure more favorable terms on existing loans. His dedication and expertise are unmatched.",
        avatar: "/avtar1.png",
        name: "Ankit Bajaj",
        designation: "Bajaj Equipment Ltd, Delhi",
    },
    {
        companyLogo: "/companyLogo3.png",
        title: "Expert Guidance and Seamless Support",
        description:
            "I had an excellent experience working with Amit ji and Team Dequitec to secure a loan for my business. Their expertise and guidance were invaluable throughout the process.",
        avatar: "/avtar2.png",
        name: "Sanjeev Goel",
        designation: "Rainbow Enterprises, Noida",
    },
    {
        companyLogo: "/companyLogo1.png",
        title: "Always There for My Business",
        description:
            "Ankur ji and Team Dequitec always stand by me in any needs of my business and they helped me in every aspect of business either it's a finance or in any banking service. I will recommend their services to all my friends and dear ones. Thanks a lot for your kind support.",
        avatar: "/avtar3.png",
        name: "Murtaza Chudiwala",
        designation: "Murtaza International, Delhi",
    },
    {
        companyLogo: "/companyLogo4.png",
        title: "Turning Challenges into Opportunities",
        description:
            "As a newly incorporated business, securing funding felt like an huge task. Despite offering security, many institutions were hesitant. Mr. Ankur and his team were the exception. Their expertise and unwavering belief in my vision were instrumental in securing the necessary loan. They didn't just get us funding; they took the time to understand our business model and matched us with the absolute best loan product tailored to our specific needs.",
        avatar: "/avtar4.png",
        name: "Pawan Bhatnagar",
        designation: "Aquaflo Services, Gurgaon",
    },
];

const TestimonialsPage = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const [activeIndex, setActiveIndex] = useState(0);
    const [expandedCards, setExpandedCards] = useState({});
    const [cardsPerPage, setCardsPerPage] = useState(3);
    const totalCards = testimonials.length;
    const [slideDirection, setSlideDirection] = useState("right");
    const [textOverflows, setTextOverflows] = useState({});
    const textRefs = useRef({});

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (isMobile) {
            setCardsPerPage(1);
        } else if (isTablet) {
            setCardsPerPage(2);
        } else {
            setCardsPerPage(3);
        }
    }, [isMobile, isTablet]);

    useEffect(() => {
        Object.keys(textRefs.current).forEach(id => {
            const element = textRefs.current[id];
            if (element) {
                const isOverflowing = element.scrollHeight > element.clientHeight;
                setTextOverflows(prev => ({
                    ...prev,
                    [id]: isOverflowing
                }));
            }
        });
    }, [activeIndex, cardsPerPage]);

    const handlePrev = () => {
        setSlideDirection("left");
        setActiveIndex((prev) => {
            return (prev - 1 + Math.ceil(totalCards / cardsPerPage)) % Math.ceil(totalCards / cardsPerPage);
        });
    };

    const handleNext = () => {
        setSlideDirection("right");
        setActiveIndex((prev) => {
            return (prev + 1) % Math.ceil(totalCards / cardsPerPage);
        });
    };

    const getVisibleTestimonials = () => {
        const startIndex = (activeIndex * cardsPerPage) % totalCards;
        const visibleCards = [];

        for (let i = 0; i < cardsPerPage; i++) {
            const index = (startIndex + i) % totalCards;
            visibleCards.push({
                ...testimonials[index],
                id: index
            });
        }

        return visibleCards;
    };

    const toggleDescription = (id) => {
        setExpandedCards(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    return (
        <Container maxWidth="xl" sx={{ py: { xs: 3, md: 6 } }}>
            <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                alignItems={{ xs: "center", md: "flex-start" }}
                justifyContent="center"
                gap={{ xs: 4, md: 10 }}
                mb={4}
                sx={{ maxWidth: "1100px", mx: "auto" }}
            >
                <Box sx={{
                    maxWidth: "800px",
                    textAlign: { xs: 'center', md: 'left' }
                }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 3,
                            justifyContent: { xs: 'center', md: 'flex-start' }
                        }}
                    >
                        <Box
                            sx={{
                                width: "50px",
                                height: "3px",
                                backgroundColor: "#004AAD",
                                mr: 1,
                            }}
                        />
                        <Typography
                            variant="h6"
                            sx={{ fontWeight: "bold", color: "#004AAD" }}
                        >
                            Testimonials
                        </Typography>
                    </Box>

                    <Typography
                        variant="h4"
                        color="#333333"
                        fontWeight="bold"
                        sx={{ mb: 4, fontSize: { xs: '24px', md: '32px' } }}
                    >
                        What Our Clients Say About Us
                    </Typography>

                    <Typography
                        variant="body1"
                        color="#555555"
                        sx={{ maxWidth: "600px", mx: { xs: 'auto', md: '0' } }}
                    >
                        Real experiences from real customers. Discover how Dequitec has helped businesses grow, succeed, and overcome challenges with trusted financial solutions.
                    </Typography>
                </Box>

                <Box
                    component="img"
                    src="/TestimonialPageIcon.png"
                    alt="Testimonials"
                    sx={{
                        maxWidth: { xs: "200px", md: "300px" },
                        height: "auto",
                    }}
                />
            </Box>

            <Box sx={{ mt: 2 }}>
                <Typography
                    variant="h5"
                    color="#333333"
                    fontWeight="bold"
                    textAlign="center"
                    mb={4}
                    sx={{ fontSize: { xs: '20px', md: '24px' } }}
                >
                    What are they saying?
                </Typography>

                <Box sx={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '1200px',
                    margin: '0 auto',
                    mb: 4,
                    overflow: 'hidden'
                }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: { xs: 3, md: 4 },
                            width: '100%',
                            transition: 'transform 0.5s ease-in-out',
                            animation: `${slideDirection === "right" ? "slideInRight" : "slideInLeft"} 0.5s forwards`,
                            "@keyframes slideInRight": {
                                "0%": { opacity: 0, transform: "translateX(20px)" },
                                "100%": { opacity: 1, transform: "translateX(0)" }
                            },
                            "@keyframes slideInLeft": {
                                "0%": { opacity: 0, transform: "translateX(-20px)" },
                                "100%": { opacity: 1, transform: "translateX(0)" }
                            }
                        }}
                    >
                    {getVisibleTestimonials().map((testimonial, index) => (
                        <Card
                            key={index}
                            sx={{
                                width: { xs: '85%', sm: '350px', md: '360px' },
                                border: '1px solid #e0e0e0',
                                borderRadius: '10px',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                overflow: 'hidden',
                                p: { xs: 2, md: 3 },
                                backgroundColor: 'white',
                                display: 'flex',
                                flexDirection: 'column',
                                    height: '100%',
                                    alignSelf: 'stretch',
                                    maxHeight: { sm: '520px', md: '520px' }
                            }}
                        >
                            <Box
                                component="img"
                                src={testimonial?.companyLogo}
                                alt="Company Logo"
                                sx={{
                                    height: { xs: 40, md: 50 },
                                    objectFit: 'contain',
                                    mb: 2.5,
                                    alignSelf: 'flex-start'
                                }}
                            />

                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                color="#333333"
                                textAlign="left"
                                mb={2}
                                sx={{ fontSize: { xs: '14px', md: '15px' } }}
                            >
                                {testimonial?.title}
                            </Typography>

                            <Box sx={{ position: 'relative', mb: 2.5, flexGrow: 1, overflow: 'auto' }}>
                                {expandedCards[testimonial?.id] ? (
                                    <>
                                        <Typography
                                            variant="body2"
                                            color="#555555"
                                            sx={{
                                                fontSize: { xs: '11px', md: '12px' },
                                                lineHeight: 1.6,
                                                textAlign: 'left',
                                            }}
                                        >
                                            {testimonial.description}
                                        </Typography>
                                        <Typography
                                            component="span"
                                            onClick={() => toggleDescription(testimonial.id)}
                                            sx={{
                                                color: '#004AAD',
                                                fontWeight: 'bold',
                                                fontSize: { xs: '11px', md: '12px' },
                                                cursor: 'pointer',
                                                display: 'inline-block',
                                                mt: 1,
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                }
                                            }}
                                        >
                                            view less...
                                        </Typography>
                                    </>
                                ) : (
                                        <>
                                            <Box sx={{ position: 'relative' }}>
                                    <Typography
                                        variant="body2"
                                        color="#555555"
                                                    ref={el => textRefs.current[testimonial.id] = el}
                                        sx={{
                                            fontSize: { xs: '11px', md: '12px' },
                                            lineHeight: 1.6,
                                            textAlign: 'left',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 4,
                                            WebkitBoxOrient: 'vertical',
                                        mb: 1
                                    }}
                                        >
                                            {testimonial?.description}
                                            </Typography>
                                        {textOverflows[testimonial?.id] && (
                                            <Typography
                                                component="span"
                                                onClick={() => toggleDescription(testimonial.id)}
                                                sx={{
                                                    color: '#004AAD',
                                                    fontWeight: 'bold',
                                                    fontSize: { xs: '11px', md: '12px' },
                                                    cursor: 'pointer',
                                                            display: 'inline-block',
                                                            position: 'absolute',
                                                            bottom: 0,
                                                            right: 0,
                                                            backgroundColor: 'white',
                                                            pl: 1,
                                                    '&:hover': {
                                                        textDecoration: 'underline',
                                                    }
                                                }}
                                            >
                                                view more...
                                            </Typography>
                                        )}
                                    </Box>
                                        </>
                                )}
                            </Box>

                            <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                color="#333333"
                                textAlign="left"
                                sx={{ fontSize: { xs: '14px', md: '16px' } }}
                            >
                                {testimonial.name}
                            </Typography>

                            <Typography
                                variant="body2"
                                color="#666666"
                                textAlign="left"
                                sx={{ fontSize: { xs: '12px', md: '14px' }, mb: 2 }}
                            >
                                {testimonial?.designation}
                            </Typography>

                            <Box
                                component="img"
                                src={testimonial?.avatar}
                                alt={testimonial?.name}
                                sx={{
                                    width: { xs: 90, md: 100 },
                                    height: { xs: 90, md: 100 },
                                    borderRadius: '50% 0 50% 50%',
                                    boxShadow: '0 6px 12px rgba(0,0,0,0.2)',
                                        objectFit: 'cover'
                                }}
                            />
                        </Card>
                    ))}
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4, mb: 6 }}>
                    <IconButton
                        onClick={handlePrev}
                        sx={{
                            backgroundColor: "#0047AB",
                            color: "white",
                            width: { xs: 40, md: 50 },
                            height: { xs: 40, md: 50 },
                            borderRadius: "50%",
                            boxShadow: "0px 3px 6px rgba(0,0,0,0.1)",
                            "&:hover": {
                                backgroundColor: "#003A87",
                            }
                        }}
                    >
                        <ChevronLeftIcon fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                    <IconButton
                        onClick={handleNext}
                        sx={{
                            backgroundColor: "#0047AB",
                            color: "white",
                            width: { xs: 40, md: 50 },
                            height: { xs: 40, md: 50 },
                            borderRadius: "50%",
                            boxShadow: "0px 3px 6px rgba(0,0,0,0.1)",
                            "&:hover": {
                                backgroundColor: "#003A87",
                            }
                        }}
                    >
                        <ChevronRightIcon fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                </Box>

                <NextStepCard />
            </Box>
        </Container>
    );
};

export default TestimonialsPage; 